import React, {useEffect} from 'react';
import {useRef} from 'react';
import {View, Animated, StyleSheet, Platform} from 'react-native';
import {primaryColor400, primaryColor500, primaryColor700} from './utils';

const Pulse = () => {
   const scaleValue = useRef(new Animated.Value(1)).current;
   const opacityValue = useRef(new Animated.Value(1)).current;

   useEffect(() => {
      Animated.loop(
         Animated.sequence([
            Animated.parallel([
               Animated.timing(scaleValue, {
                  toValue: 0.3,
                  duration: 0,
                  useNativeDriver: true,
               }),
               Animated.timing(opacityValue, {
                  toValue: 2,
                  duration: 500,
                  useNativeDriver: true,
               }),
            ]),
            Animated.parallel([
               Animated.timing(scaleValue, {
                  toValue: 1,
                  duration: 1000,
                  useNativeDriver: true,
               }),
               Animated.timing(opacityValue, {
                  toValue: 0,
                  duration: 1000,
                  useNativeDriver: true,
               }),
            ]),
         ]),
      ).start();
   }, []);

   const animatedStyle = {
      transform: [{scale: scaleValue}],
      opacity: opacityValue,
   };

   return (
      <View style={styles.container}>
         <Animated.View style={[styles.circle, animatedStyle]} />
      </View>
   );
};

const styles = StyleSheet.create({
   container: {
      alignItems: 'center',
      justifyContent: 'center',
      position: 'absolute',
   },
   circle: {
      width: 120,
      ...Platform.select({
         web: {
            width: 112,
         },
      }),
      height: 120,
      borderRadius: 90,
      borderWidth: 15,
      borderColor: primaryColor500,
   },
});

export default Pulse;
